<etoh-page-form
  [name]="'Address'"
  [id]="id"
  [standalone]="standalone"
  [dataType]="'addresses'"
  [fields]="fields"
  [model]="model"
  [insertFunction]="insertFunction"
  [shouldPrevent]="shouldPrevent"
></etoh-page-form>
